module.exports = __webpack_public_path__ + "static/media/dave.f0cc9615.jpg";